import {ObdDetailsComponent} from 'src/app/views/obd/obd-details/obd-details.component';
import {ObdListComponent} from 'src/app/views/obd/obd-list/obd-list.component';
import {InActiveUserComponent} from 'src/app/views/in-active-user/in-active-user.component';

import { PoliciesComponent } from './booking/policies/policies.component';
import { PaymnetExportableComponent } from './booking/paymnet-exportable/paymnet-exportable.component';
import { NumbersOnlyDirective } from './../common/directives/numbers-only.directive';
import { LoginPageComponent } from './booking/login-page/login-page.component';
import { HomeMiddleContentComponent } from './home/home-middle-content/home-middle-content.component';
import { PayModalComponent } from './booking/pay-modal/pay-modal.component';
import { EditPaymentInfoComponent } from './booking/edit-payment-info/edit-payment-info.component';
import { DeletePaymentInfoComponent } from './booking/delete-payment-info/delete-payment-info.component';
import { AddPaymentInfoComponent } from './booking/add-payment-info/add-payment-info.component';
import { AgencyMapComponent } from './booking/agency-map/agency-map.component';
import { FilterComponent } from './booking/filter/filter.component';
import { LayoutInnerComponent } from './shared/layout-inner/layout-inner.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { MyNotificationsComponent } from './booking/my-notifications/my-notifications.component';
import { MyFavouritsComponent } from './booking/my-favourits/my-favourits.component';
import { ServiceTermsAndConditionComponent } from './service-terms-and-condition/service-terms-and-condition.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { RentalVehicleNotAvailableComponent } from './booking/rental-vehicle-not-available/rental-vehicle-not-available.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';


import { ViewPaymentComponent } from './booking/view-payment/view-payment.component';
import { ViewMyProfileComponent } from './profile/view-my-profile/view-my-profile.component';
import { CustomerEligibilityComponent } from './booking/customer-eligibility/customer-eligibility.component';
import { EditMyProfileComponent } from './profile/edit-my-profile/edit-my-profile.component';
import { ExtendRentalTimeModalComponent } from './booking/extend-rental-time-modal/extend-rental-time-modal.component';
import { UpdateAdditionalModalComponent } from './booking/update-additional-modal/update-additional-modal.component';
import { AddRemoveExtrasModalComponent } from './booking/add-remove-extras-modal/add-remove-extras-modal.component';
import { ModifyPickupModalComponent } from './booking/modify-pickup-modal/modify-pickup-modal.component';
import { ModificationTypeModalComponent } from './booking/modification-type-modal/modification-type-modal.component';
import { CancelConfirmationModalComponent } from './booking/cancel-confirmation-modal/cancel-confirmation-modal.component';
import { CancelationModalComponent } from './booking/cancelation-modal/cancelation-modal.component';
import { AddReviewsComponent } from './booking/add-reviews/add-reviews.component';
import { ViewBookingDetailsComponent } from './booking/view-booking-details/view-booking-details.component';
import { ViewBookedCarComponent } from './booking/view-booked-car/view-booked-car.component';
import { ViewMyCarComponent } from './booking/view-my-car/view-my-car.component';
import { TermsAndConditionsComponent } from './booking/terms-and-conditions/terms-and-conditions.component';
import { ViewBookingComponent } from './booking/view-booking/view-booking.component';
import { MyBookingsComponent } from './booking/my-bookings/my-bookings.component';
import {GoogleMapPinComponent} from 'src/app/views/booking/google-map-pin/google-map-pin.component';
import { ConfirmationComponent } from './booking/confirmation/confirmation.component';
import { PaymentComponent } from './booking/payment/payment.component';
import { PaymentEditComponent } from 'src/app/views/booking/payment-edit/payment-edit.component';
import {PaymentSharedComponent} from 'src/app/views/booking/payment-shared/payment-shared.component'

import { DriverComponent } from './booking/driver/driver.component';
import { BookingVehicleTypeComponent } from './booking/booking-vehicle-type/booking-vehicle-type.component';
import { LoginModalBodyComponent } from './booking/login-modal-body/login-modal-body.component';

import { ChargeSummaryViewBookingComponent } from './booking/charge-summary-view-booking/charge-summary-view-booking.component';
import { ViewReviewsComponent } from './booking/view-reviews/view-reviews.component';
import { BookingDetailsComponent } from './booking/booking-details/booking-details.component';
import { MainComponent } from './search-location/Main/Main.component';
import { FindYourIdealCarComponent } from './booking/find-your-ideal-car/find-your-ideal-car.component';
import { ChargeSummaryComponent } from './booking/charge-summary/charge-summary.component';
import { BookingPageComponent } from './booking/booking-page/booking-page.component';
import { ResultOptionsComponent } from './booking/result-options/result-options.component';
import {VehicleCardForModalComponent} from 'src/app/views/booking/vehicle-card-for-modal/vehicle-card-for-modal.component'
import { ReviewsModalBodyComponent } from './search-location/reviews-modal-body/reviews-modal-body.component';

import { ImageService } from './../services/image.service';
import { ImageGalleryComponent } from './search-location/image-gallery/image-gallery.component';
import { SearchVehiclePageComponent } from './search-location/search-vehicle-page/search-vehicle-page.component';
import { GoogleMapComponent } from './search-location/google-map/google-map.component';
import { SearchSectionComponent } from './search-location/search-section/search-section.component';
import { SearchLocationPageComponent } from './search-location/search-location-page/search-location-page.component';

import { FailureBookingComponent } from 'src/app/views/booking/failure-booking/failure-booking.component';
import { DriverUpdateComponent } from 'src/app/views/booking/driver-update/driver-update.component';
import { RegisterComponent } from './auth/register/register.component';
import { AppComponent } from './../app.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewComponent } from './customer/view/view.component';
import { LayoutComponent } from './shared/layout/layout.component';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { BannerComponent } from './home/banner/banner.component';
import { SearchComponent } from './home/search/search.component';
import { EazyRentComponent } from './home/eazy-rent/eazy-rent.component';
import { BestRentalDealComponent } from './home/best-rental-deal/best-rental-deal.component';
import { CountersComponent } from './home/counters/counters.component';
import { TopDealsComponent } from './home/top-deals/top-deals.component';
import { PopularCarsComponent } from './home/popular-cars/popular-cars.component';
import { TestimonialsComponent } from './home/testimonials/testimonials.component';
import { DownloadAppComponent } from './home/download-app/download-app.component';
import {ImageHandlerComponent} from 'src/app/views/image-handler/image-handler.component'
import { LayoutModule } from './shared/layout.module';
import { HomePageComponent } from './home/home-page/home-page.component';
import { RouterModule, Routes } from '@angular/router';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FlexLayoutModule } from '@angular/flex-layout';
import { LoginComponent } from './auth/login/login.component';
import {ResetPasswordComponent} from './auth/reset-password/reset-password.component'
import { ModuleWithProviders } from "@angular/core";
import { MAT_LABEL_GLOBAL_OPTIONS, MatNativeDateModule, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
 import { MatAutocompleteModule } from '@angular/material/autocomplete';
// import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
// import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
// import { MatChipsModule } from '@angular/material/chips';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
// import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
// import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSliderModule } from '@angular/material/slider';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
// import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
// import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { AuthModule } from './auth/auth.module';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { UiSwitchModule } from 'ngx-ui-switch';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { GoogleMapsModule } from '@angular/google-maps'
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AgmCoreModule } from '@agm/core';
import { environment } from 'src/environments/environment';
import { HttpClientModule, HttpClient } from "@angular/common/http";
import { DateFormatPipe } from './../common/pipes/DateFormatPipe'

import { GalleryModule } from '@ngx-gallery/core';
import { LightboxModule } from '@ngx-gallery/lightbox';
import { SimpleNotificationsModule } from 'angular2-notifications';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CountdownModule } from 'ngx-countdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { NgwWowModule } from 'ngx-wow';

import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {PoliciesIconsComponent} from 'src/app/views/search-location/policies-icons/policies-icons.component'
//import {PolicySummaryDialogComponent} from 'src/app/views/search-location/policy-summary-dialog/policy-summary-dialog.component'
import {VehicleCardAbstractComponent} from 'src/app/views/booking/vehicle-card-abstract/vehicle-card-abstract.component'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { LayoutObdComponent } from './shared/layout-obd/layout-obd.component';
import { EmailVerificationComponent } from './auth/email-verification/email-verification.component';
import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';

import { FaqComponent } from './faq/faq.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DeclinedComponent } from './booking/declined/declined.component';
import { FailedComponent } from './booking/failed/failed.component';




// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'Localization/getAllResources/', '');
}



const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      { path: 'home', component: HomePageComponent },//, canActivate: [AuthGuard]
      { path: 'login', component: LoginComponent },
      { path: 'login-page', component: LoginPageComponent },
      { path: 'register', component: RegisterComponent },
      {path:'reset-password',component:ResetPasswordComponent},
      { path: 'email-verification', component: EmailVerificationComponent },
    ]
  },
  {
    path: '',
    component: LayoutInnerComponent,
    children: [
      { path: 'searchByLocation', component: MainComponent },
      { path: 'searchByVehicle', component: SearchVehiclePageComponent },
      { path: 'ResultOptionsComponent', component: ResultOptionsComponent },
      { path: 'booking', component: BookingPageComponent },
      { path: 'My-Bookings', component: MyBookingsComponent,canActivate: [AuthGuard] },
      { path: 'view-booking', component: ViewBookingComponent,canActivate: [AuthGuard] },
      { path: 'ConfirmationComponent', component: ConfirmationComponent },
      { path: 'FailurePayment', component: FailureBookingComponent },
      { path: 'Edit-My-Profile', component: EditMyProfileComponent },
      { path: 'View-My-Profile', component: ViewMyProfileComponent},
      { path: 'About-Us', component: AboutUsComponent},
      { path: 'Service-Terms-And-Condition', component:ServiceTermsAndConditionComponent },
      { path: 'Contact-Us', component: ContactUsComponent},
      { path: 'My-Favourits', component: MyFavouritsComponent},
      { path: 'My-Notifications', component: MyNotificationsComponent},
      { path: 'update-booking-date', component: ModifyPickupModalComponent},
      { path: 'update-booking-extra', component: AddRemoveExtrasModalComponent},
      { path: 'extend-rental-time', component: ExtendRentalTimeModalComponent},
      { path: 'update-additional-driver', component: UpdateAdditionalModalComponent},
      {path: 'pay', component: PayModalComponent},
      { path: 'payment', component: PaymnetExportableComponent },
      { path: 'in-active-user', component: InActiveUserComponent },
      { path: 'FAQ', component: FaqComponent},
      { path: 'Privacy-Policy', component: PrivacyPolicyComponent},

    ]
  },
  {
    path: '',
    component: LayoutObdComponent,
    children: [
      { path: 'obd-list', component: ObdListComponent },
      { path: 'obd-list/obd-details', component: ObdDetailsComponent }
    ]
  }


];


@NgModule({
  declarations: [
    ViewComponent, BannerComponent, SearchComponent, EazyRentComponent, BestRentalDealComponent, CountersComponent, TopDealsComponent, PopularCarsComponent,TestimonialsComponent, DownloadAppComponent, HomePageComponent ,
   SearchSectionComponent, SearchLocationPageComponent,GoogleMapComponent,SearchLocationPageComponent,SearchVehiclePageComponent,ImageGalleryComponent,ReviewsModalBodyComponent,ResultOptionsComponent,BookingPageComponent, FindYourIdealCarComponent,ChargeSummaryComponent,MainComponent,
        BookingDetailsComponent, LoginModalBodyComponent, BookingVehicleTypeComponent, DriverComponent, PaymentComponent,PaymentEditComponent, ConfirmationComponent, GoogleMapPinComponent, MyBookingsComponent, ViewBookingComponent, ViewMyCarComponent, ViewBookedCarComponent, ViewBookingDetailsComponent, AddReviewsComponent, CancelationModalComponent, CancelConfirmationModalComponent,
       ModificationTypeModalComponent, ModifyPickupModalComponent, AddRemoveExtrasModalComponent, UpdateAdditionalModalComponent, ExtendRentalTimeModalComponent ,TermsAndConditionsComponent,ViewReviewsComponent,ChargeSummaryViewBookingComponent ,DriverUpdateComponent,EditMyProfileComponent,CustomerEligibilityComponent,ViewMyProfileComponent,ViewPaymentComponent,
       ChangePasswordComponent,VehicleCardForModalComponent,RentalVehicleNotAvailableComponent,MyFavouritsComponent,MyNotificationsComponent,FilterComponent,
    AboutUsComponent, ContactUsComponent, ServiceTermsAndConditionComponent,PoliciesIconsComponent,AgencyMapComponent,VehicleCardAbstractComponent,ImageHandlerComponent, AddPaymentInfoComponent,DeletePaymentInfoComponent,EditPaymentInfoComponent,PayModalComponent,HomeMiddleContentComponent,LoginPageComponent ,PaymentSharedComponent,PaymnetExportableComponent,PoliciesComponent,ObdListComponent,ObdDetailsComponent,InActiveUserComponent,FaqComponent,PrivacyPolicyComponent, DeclinedComponent, FailedComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FontAwesomeModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    MatDatepickerModule,
    MatButtonModule,
    NgxPageScrollModule,
    BrowserAnimationsModule,
    CarouselModule,
    FlexLayoutModule,
    MatIconModule,
    MatListModule,
    // MatSidenavModule,
    // MatToolbarModule,
    AuthModule,
    GooglePlaceModule,
    GoogleMapsModule,
     MatAutocompleteModule,
    // MatBadgeModule,
    MatButtonModule,
    MatButtonToggleModule,
    // MatCardModule,
    MatCheckboxModule,
    // MatChipsModule,
    //MatDatepickerModule,
    MatExpansionModule,
    // MatGridListModule,
    MatFormFieldModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    // MatRippleModule,
    MatSelectModule,
    // MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    // MatSnackBarModule,
    MatSortModule,
    // MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatTableModule,
    MatFormFieldModule,
    MatStepperModule,
    MatPaginatorModule,
    MatRadioModule,
    BrowserAnimationsModule,
    InfiniteScrollModule,
    GalleryModule,
    LightboxModule,
    HttpClientModule,
    MatDialogModule,
    TooltipModule,
    BrowserModule,
    NgbModule,
    NgxIntlTelInputModule,
    LazyLoadImageModule,
    NgwWowModule,
    NgxMatSelectSearchModule,




    AgmCoreModule.forRoot({
      apiKey: environment.googleKey,
      libraries: ['geometry','places'],
      language: getSelectedLang()
    }),
    MatGoogleMapsAutocompleteModule,
    SimpleNotificationsModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      },
      isolate: true,
    }),

    AuthModule,
    CountdownModule,


  ],
  exports: [
    MatDatepickerModule,
    MatButtonModule,
    RouterModule,

  ],
  providers: [MatFormFieldModule, MatDatepickerModule, DateFormatPipe],

})
export class ViewsModule { }


function getSelectedLang(){


  return localStorage.getItem('lang')==null?'en':JSON.parse(localStorage.getItem('lang')).isoCode2;
}

